// config/roleAccess.js

import { ROLES } from "./roles";

export const ROLE_ACCESS = {
  [ROLES.KIOSK]: [
    "/",
    "/projects",
    "/newproject",
    "/conference-room",
    "/feedback",
    "/whatsapp"
  ],
  [ROLES.OPERATIONS]: [
    "/finance/get-projects",
    "/finance/get-schedules",
    "/finance/projects/",
    "/finance/save-payment-terms",
    "/finance/get-payment-terms/",
  ],
};